<div class="screen">
  <app-navbar></app-navbar>

  <div class="dashboard-container">
    <div class="header-section">
      <div class="header-left">
        <h1 class="dashboard-title">Bid History</h1>
      </div>

      <div class="header-right">
        <button class="select-all-history-btn">Select All Time History</button>
        <div class="date-picker-badge">
          <button class="nav-btn" (click)="changeDay(-1)" [disabled]="isLoading">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="3"
                 stroke-linecap="round" stroke-linejoin="round">
              <path d="M15 18l-6-6 6-6"/>
            </svg>
          </button>

          <div class="date-display" (click)="picker.open()" style="cursor: pointer;">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2.2"
                 stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
              <line x1="16" y1="2" x2="16" y2="6"/>
              <line x1="8" y1="2" x2="8" y2="6"/>
              <line x1="3" y1="10" x2="21" y2="10"/>
              <path d="M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01M16 18h.01"/>
            </svg>
            <span>{{ selectedDate.toJSDate() | date:'d MMMM yyyy' }}</span>
            <input matInput [matDatepicker]="picker" 
                   [value]="selectedDate"
                   (dateChange)="onDateChange($event)"
                   [max]="maxDate"
                   style="position: absolute; opacity: 0; width: 0; height: 0; pointer-events: none;">
            <mat-datepicker #picker panelClass="premium-calendar"></mat-datepicker>
          </div>

          <button class="nav-btn" (click)="changeDay(1)" [disabled]="isLoading || selectedDate >= maxDate">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="3"
                 stroke-linecap="round" stroke-linejoin="round">
              <path d="M9 18l6-6-6-6"/>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="list-container">
        <div class="list-controls narrow">
          <div class="search-wrap" role="search" aria-label="Bid search">
            <span class="search-icon" aria-hidden="true">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                   stroke="#000000" stroke-width="2.5"
                   stroke-linecap="round" stroke-linejoin="round">
                <circle cx="11" cy="11" r="8"/>
                <line x1="21" y1="21" x2="16.65" y2="16.65"/>
              </svg>
            </span>
            <input
              class="search-input"
              type="search"
              placeholder="Search"
              aria-label="Search bids by name"
              [value]="searchTerm"
              (input)="onSearchChange($event)"
            />
          </div>
          <div class="controls-right">
            <div class="filter-attached">
              <div class="filter-by">Filter By</div>
              <div class="filter-select-pill">
                <select
                  class="filter-select"
                  (change)="onCombinedFilterChange($event)"
                  [value]="selectedFilter"
                >
                  <option value="All">All Bids</option>
                  <option value="userType:Consumer">Consumers</option>
                  <option value="userType:Prosumer">Prosumers</option>
                  <option value="bidType:Day ahead">Day ahead</option>
                  <option value="bidType:Monthly">Monthly</option>
                  <option value="bidType:Preferential">Preferential</option>
                </select>
                <span class="dropdown-arrow"></span>
              </div>
            </div>
          </div>
        </div>

        <div class="table-head" aria-hidden="true">
          <div class="col col-date">Date</div>
          <div class="col col-name">Name</div>
          <div class="col col-type">User Type</div>
          <div class="col col-units">Energy Units</div>
          <div class="col col-price">Price</div>
          <div class="col col-bidtype">Bid Type</div>
          <div class="col col-status">Status</div>
        </div>

        <div *ngIf="isLoading || errorMessage" class="center-message-wrapper">
          <div *ngIf="isLoading" class="center-message">
            <div class="spinner"></div>
            <span>Loading bids...</span>
          </div>
          <div *ngIf="errorMessage" class="center-message error">
            <span>{{ errorMessage }}</span>
          </div>
        </div>

        <div
          *ngIf="!isLoading && !errorMessage && filteredBids.length === 0"
          class="center-message-wrapper"
        >
          <div class="center-message">
            <span>{{
              masterBids.length > 0
                ? "No bids match your filters."
                : "No bids found for the selected date."
            }}</span>
          </div>
        </div>

        <ul
          class="bid-list"
          role="list"
          *ngIf="!isLoading && !errorMessage && filteredBids.length > 0"
        >
          <li
            class="bid-row"
            *ngFor="let bid of filteredBids; let i = index"
            [class.highlight]="selectedBidId === bid.id"
            (click)="selectBid(bid.id)"
            role="listitem"
          >
            <div class="col col-date">{{ bid.date }}</div>
            <div class="col col-name bold-col">{{ bid.participant }}</div>
            <div class="col col-type bold-col">{{ bid.user_type }}</div>
            <div class="col col-units">{{ bid.amount }} KWh</div>
            <div class="col col-price">₹ {{ bid.price }}/kWh</div>
            <div class="col col-bidtype">
              {{
                bid.bid_type === "Preferential Exchange of Energy"
                  ? "Preferential"
                  : bid.bid_type
              }}
            </div>
            <div class="col col-status">
              <span
                class="status-pill"
                [ngClass]="{
                  active: bid.status.toLowerCase() === 'active',
                  accepted: bid.status.toLowerCase() === 'accepted',
                  rejected: bid.status.toLowerCase() === 'rejected'
                }"
              >
                {{ bid.status }}
              </span>
            </div>
          </li>
        </ul>

        <!-- pagination block: only show when there are visible rows -->
        <div
          class="list-footer narrow"
          *ngIf="!isLoading && !errorMessage && filteredBids.length > 0"
        >
          <div class="range-info">
            Showing {{ visibleRange().from }} - {{ visibleRange().to }} of
            {{ totalItems }} bids
          </div>

          <div class="pagination-controls">
            <button
              (click)="prevPage()"
              [disabled]="currentPage === 1 || isLoading"
            >
              Prev
            </button>

            <ng-container *ngFor="let p of pagesArray">
              <ng-container *ngIf="shouldShowPageButton(p)">
                <button
                  (click)="goToPage(p)"
                  [class.active]="currentPage === p"
                  [disabled]="isLoading"
                >
                  {{ p }}
                </button>
              </ng-container>
            </ng-container>

            <button
              (click)="nextPage()"
              [disabled]="currentPage === totalPages || isLoading"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="dashboard-footer">Powered By Hygge Energy</div>
  </div>
</div>
